/**
 * Rundes Profilbild (REQ-20 §4). Liegt ein Bild vor (`auth.profileImage` aus
 * Microsoft Graph), wird es gezeigt; sonst die Initialen auf `--accent-soft`
 * mit `--accent-2` als Schriftfarbe.
 */

import type { ReactElement } from 'react';

export interface ProfileAvatarProps {
  /** Bilddaten aus dem Auth-Kontext; leer, wenn Graph kein Bild liefert. */
  image: string;
  name: string | null;
  /** Kantenlänge in Pixeln. */
  size: number;
}

/** „Pio Virzi" → „PV"; ohne Namen bleibt ein Platzhalter. */
function initialsOf(name: string | null): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const initials = parts
    .slice(0, 2)
    .map((part) => [...part][0] ?? '')
    .join('');
  return initials === '' ? '?' : initials.toUpperCase();
}

export function ProfileAvatar({ image, name, size }: ProfileAvatarProps): ReactElement {
  const style = { width: `${String(size)}px`, height: `${String(size)}px` };

  if (image !== '') {
    return <img className="iwm-profile-avatar" src={image} alt="" style={style} />;
  }

  return (
    <span
      className="iwm-profile-avatar iwm-profile-avatar-initials"
      aria-hidden="true"
      style={{ ...style, fontSize: `${String(Math.round(size * 0.38))}px` }}
    >
      {initialsOf(name)}
    </span>
  );
}

export default ProfileAvatar;
